import React, {useEffect, useRef, useState} from 'react';
import type {SourceBrandIntro, BrandIntroTextPatch} from '../../protocol/source-brand-intro';

function IntroInput({value, title, onCommit}: {value: string; title: boolean; onCommit: (value: string) => void}) {
  const [draft, setDraft] = useState(value), [error, setError] = useState('');
  const focused = useRef(false), composing = useRef(false), deferred=useRef(false),commit=useRef(onCommit),before=useRef(value);
  useEffect(() => { if (!focused.current && !composing.current) { setDraft(value); setError(''); } }, [value]);
  const save = (text:string) => {
    deferred.current=false;
    if (title && !text.trim()) { setError('카드 제목을 입력해 주세요.'); return; }
    try { if (text !== before.current) commit.current(text); setError(''); }
    catch (e) { setError(e instanceof Error ? e.message : '오프닝 카드를 바꾸지 못했어요. 다시 시도해 주세요.'); }
  };
  return <label className="source-field-label">
    {title ? '카드 제목' : '카드 부제 · 비우면 표시하지 않아요'}
    <input type="text" aria-label={title ? '오프닝 카드 제목' : '오프닝 카드 부제'} aria-invalid={!!error}
      className="source-field" value={draft} spellCheck={false} onFocus={() => {focused.current = true;commit.current=onCommit;before.current=value;}}
      onChange={e => {setDraft(e.currentTarget.value); setError('');}}
      onCompositionStart={() => {composing.current = true;}}
      onCompositionEnd={e => {composing.current = false;setDraft(e.currentTarget.value);if(deferred.current)save(e.currentTarget.value);}}
      onBlur={e => {focused.current = false;if(composing.current)deferred.current=true;else save(e.currentTarget.value);}}
      onKeyDown={e => {if (e.key === 'Enter' && !e.nativeEvent.isComposing && !composing.current) e.currentTarget.blur();}}/>
    {error && <span role="alert">{error}</span>}
  </label>;
}
/** Commit patches, not stale payloads. Host re-reads live native state inside functional setter. */
export function SourceBrandIntroFields({data, onCommit}: {data: SourceBrandIntro; onCommit: (patch: BrandIntroTextPatch) => void}) {
  return <div data-testid="source-brand-intro-fields">
    <IntroInput value={data.title} title onCommit={title => onCommit({title})}/>
    <IntroInput value={data.subtitle ?? ''} title={false} onCommit={subtitle => onCommit({subtitle})}/>
  </div>;
}
